import { throttleUntilResolve, jwtDecode, isTokenExpired } from '@dtvgo/utils';

function getAuthHeadersGetter({
  initialData,
  authorizer,
  onError,
  refreshSecondsBefore: secondsBefore = 90,
  checkToken
}) {
  const data = {
    accessToken: void 0,
    refreshToken: void 0,
    issuedAt: void 0
  };
  let refreshTokenTimeout;
  const getToken = throttleUntilResolve(async () => {
    const response = await authorizer.getToken(data);
    updateData(response.data);
  });
  const refreshAccessToken = throttleUntilResolve(async () => {
    try {
      await checkToken?.();
    } catch {
    }
    const response = await authorizer.refreshToken(data);
    updateData(response.data);
  });
  function updateData(updatedData) {
    data.accessToken = updatedData.accessToken;
    data.refreshToken = updatedData.refreshToken;
    data.issuedAt = updatedData.issuedAt ?? Date.now();
    const { exp, iat } = jwtDecode(updatedData.accessToken);
    const expirationTime = exp - iat;
    if (refreshTokenTimeout)
      clearTimeout(refreshTokenTimeout);
    refreshTokenTimeout = setTimeout(() => {
      refreshAccessToken().catch(onError);
      refreshTokenTimeout = void 0;
    }, (expirationTime - secondsBefore) * 1e3);
  }
  const getUpdatedAccessToken = async () => {
    const isValidAccessToken = data.accessToken && !isTokenExpired(data.accessToken, { secondsBefore, issuedAt: data.issuedAt });
    if (isValidAccessToken)
      return data.accessToken;
    const isValidRefreshToken = !!data.refreshToken && !isTokenExpired(data.refreshToken, { issuedAt: data.issuedAt });
    if (isValidRefreshToken) {
      await refreshAccessToken();
      return data.accessToken;
    }
    await getToken();
    return data.accessToken;
  };
  if (initialData)
    updateData(initialData);
  if (!data.accessToken)
    getToken().catch(onError);
  const getAuthHeaders = async () => {
    try {
      return {
        Authorization: `Bearer ${await getUpdatedAccessToken()}`
      };
    } catch (error) {
      console.error("[player-utils] getAuthHeaders error", error);
      onError(error);
      return {};
    }
  };
  const clearRefreshTimeout = () => {
    if (refreshTokenTimeout)
      clearTimeout(refreshTokenTimeout);
  };
  return {
    getAuthHeaders,
    clearRefreshTimeout
  };
}

export { getAuthHeadersGetter };
//# sourceMappingURL=getAuthHeadersGetter.js.map
